import "../../CSS/promotions-box.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { SwiperSlide, Swiper } from "swiper/react";
import { listFilter } from "../../JSON/helpers";

export default function PromotionSection({ device }) {
  const regis = "https://www.codere.mx/registro-deportes?clientType=sportsbook";

  const [promosList, setPromosList] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SERVER}/prd/mexico/fetch-promos`, {
        headers: JSON.parse(process.env.REACT_APP_SER_HEADER),
      })
      .then((res) => {
        // console.log(res.data);

        setPromosList([...res.data.filter(listFilter)]);
      })
      .catch((err) => console.log(err));
  }, []);

  const gen = (promo) => {
    return (
      <div
        className="promo-box w-100 m-auto"
        onClick={() => window.open(promo.url, "_blank")}
      >
        <div className="box-title w-75 position-relative pb-1 pt-1 m-auto text-center">
          <span className="text-white text-uppercase ">{promo.title}</span>
        </div>
        <div className="box-body">
          <img
            alt={promo.name}
            width={300}
            height={300}
            style={{ borderRadius: "14px" }}
            src={promo.image}
          />
          <div className="box-text text-center ellipsis-text">
            {promo.description}
          </div>
        </div>
        <div className="box-footer d-flex flex-column">
          <div className="box-button-wrapper d-flex mt-2 align-items-center justify-content-around">
            <div className="box-tyc">
              <span>Términos y condiciones</span>
            </div>
            <div className="box-button text-uppercase">
              <Button onClick={() => window.open(regis, "_blank")}>
                Regístrate
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const onSwiperInit = (swiper) => {
    if (promosList.length > 4) return;
    const swiperWrapper = swiper.wrapperEl;
    if (!device) swiperWrapper.style["justify-content"] = "center";
  };
  return (
    <div
      className={`w-${device ? 100 : 75} mx-auto my-0 ${
        device ? "ps-3 pe-3" : ""
      }`}
    >
      {promosList.length > 0 && (
        <>
          <h2 className="text-center fw-bold text-white my-0">Promociones</h2>

          <Swiper
            onInit={onSwiperInit}
            breakpoints={{
              0: {
                spaceBetween: 20,
                slidesPerView: 1.5,
              },
              1024: {
                slidesPerView: 4.3,
                spaceBetween: 20,
              },
            }}
          >
            {promosList.map((promo, i) => (
              <SwiperSlide key={i}>{gen(promo)}</SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </div>
  );
}
